import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';
const API_URL = process.env.NEXT_PUBLIC_API_URL;

export const allSubCategories = createAsyncThunk(
  "treatment/allSubCategories",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/sub-categories`;
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data;
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Unknown error";
      return rejectWithValue({ message: errorMessage });
    }
  }
);

const treatmentSlice = createSlice({
  name: "treatment",
  initialState: {
    treatmentList: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allSubCategories.pending, (state) => {
        state.status = "loading";
      })
      .addCase(allSubCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.treatmentList = action.payload.data;
      })
      .addCase(allSubCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
  },
});

export default treatmentSlice.reducer;
